var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutdoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0842 8.73175C10.3212 8.73175 10.5133 8.92387 10.5133 9.16087V16.6704C10.5133 16.9074 10.3212 17.0995 10.0842 17.0995C9.84717 17.0995 9.65505 16.9074 9.65505 16.6704V9.16087C9.65505 8.92387 9.84717 8.73175 10.0842 8.73175Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4864 8.94631C17.4864 9.1833 17.2943 9.37543 17.0573 9.37543L3.111 9.37543C2.87401 9.37543 2.68189 9.1833 2.68189 8.94631C2.68189 8.70931 2.87401 8.51719 3.111 8.51719L17.0573 8.51719C17.2943 8.51719 17.4864 8.70931 17.4864 8.94631Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64667 9.16915C3.47909 9.00157 3.47909 8.72987 3.64667 8.56229L9.71531 2.49365C9.88289 2.32607 10.1546 2.32607 10.3222 2.49365C10.4898 2.66123 10.4898 2.93294 10.3222 3.10052L4.25354 9.16915C4.08596 9.33674 3.81426 9.33674 3.64667 9.16915Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84634 2.49365C10.0139 2.32607 10.2856 2.32607 10.4532 2.49365L16.5218 8.56228C16.6894 8.72987 16.6894 9.00157 16.5218 9.16915C16.3543 9.33673 16.0826 9.33673 15.915 9.16915L9.84634 3.10051C9.67876 2.93293 9.67876 2.66123 9.84634 2.49365Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2681 16.7778C14.2681 17.0148 14.0759 17.2069 13.8389 17.2069H6.32939C6.09239 17.2069 5.90027 17.0148 5.90027 16.7778C5.90027 16.5408 6.09239 16.3487 6.32939 16.3487H13.8389C14.0759 16.3487 14.2681 16.5408 14.2681 16.7778Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.337 16.7778C12.574 16.7778 12.7661 16.9699 12.7661 17.2069V22.5709C12.7661 22.8079 12.574 23 12.337 23C12.1 23 11.9079 22.8079 11.9079 22.5709V17.2069C11.9079 16.9699 12.1 16.7778 12.337 16.7778Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83148 16.7775C8.06847 16.7775 8.2606 16.9696 8.2606 17.2066V22.5706C8.2606 22.8076 8.06847 22.9997 7.83148 22.9997C7.59448 22.9997 7.40236 22.8076 7.40236 22.5706V17.2066C7.40236 16.9696 7.59448 16.7775 7.83148 16.7775Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7395 13.5594C19.9765 13.5594 20.1686 13.7515 20.1686 13.9885V22.5709C20.1686 22.8079 19.9765 23 19.7395 23C19.5025 23 19.3104 22.8079 19.3104 22.5709V13.9885C19.3104 13.7515 19.5025 13.5594 19.7395 13.5594Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1993 18.9231C16.4363 18.9231 16.6284 19.1152 16.6284 19.3522V22.5706C16.6284 22.8076 16.4363 22.9997 16.1993 22.9997C15.9623 22.9997 15.7702 22.8076 15.7702 22.5706V19.3522C15.7702 19.1152 15.9623 18.9231 16.1993 18.9231Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8468 19.3525C19.8468 19.5895 19.6547 19.7816 19.4177 19.7816H16.1993C15.9623 19.7816 15.7702 19.5895 15.7702 19.3525C15.7702 19.1155 15.9623 18.9234 16.1993 18.9234H19.4177C19.6547 18.9234 19.8468 19.1155 19.8468 19.3525Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.429117 13.5594C0.666112 13.5594 0.858234 13.7515 0.858234 13.9885L0.858234 22.5709C0.858234 22.8079 0.666112 23 0.429117 23C0.192122 23 -4.17233e-07 22.8079 -4.17233e-07 22.5709L-4.17233e-07 13.9885C-4.17233e-07 13.7515 0.192122 13.5594 0.429117 13.5594Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96952 18.9231C4.20651 18.9231 4.39864 19.1152 4.39864 19.3522V22.5706C4.39864 22.8076 4.20651 22.9997 3.96952 22.9997C3.73252 22.9997 3.5404 22.8076 3.5404 22.5706V19.3522C3.5404 19.1152 3.73252 18.9231 3.96952 18.9231Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39864 19.3525C4.39864 19.5895 4.20651 19.7816 3.96952 19.7816H0.751138C0.514143 19.7816 0.322021 19.5895 0.322021 19.3525C0.322021 19.1155 0.514143 18.9234 0.751138 18.9234H3.96952C4.20651 18.9234 4.39864 19.1155 4.39864 19.3525Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4714 1.71006C19.4714 2.30255 18.9911 2.78286 18.3986 2.78286C17.8061 2.78286 17.3258 2.30255 17.3258 1.71006C17.3258 1.11757 17.8061 0.637268 18.3986 0.637268C18.9911 0.637268 19.4714 1.11757 19.4714 1.71006Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1151 1.71006C20.1151 2.65804 19.3466 3.42653 18.3986 3.42653C17.4506 3.42653 16.6821 2.65804 16.6821 1.71006C16.6821 0.762081 17.4506 -0.00640869 18.3986 -0.00640869C19.3466 -0.00640869 20.1151 0.762081 20.1151 1.71006ZM18.3986 2.78285C18.9911 2.78285 19.4714 2.30255 19.4714 1.71006C19.4714 1.11757 18.9911 0.637267 18.3986 0.637267C17.8061 0.637267 17.3258 1.11757 17.3258 1.71006C17.3258 2.30255 17.8061 2.78285 18.3986 2.78285Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoor);
export default __webpack_public_path__ + "static/media/outdoor.5478180a8b50552f829f3a6e7f62d417.svg";
export { ForwardRef as ReactComponent };